import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import selectors from '@/redux/selectors/selectors';
import getErrorSchema from './lib/getErrorSchema';
import { sanitizeStack } from '@shared/utils/formatErrorAsObject';

const OutputErrorViewer = ({ output }) => {
  const [errorComponent, setErrorComponent] = useState();
  const admin = useSelector(selectors.admin);
  const httpStatus = output?.meta?.response?.status;
  const code = output?.meta?.code;
  const stepWithOrphanedCredentials = output?.meta?.stepWithOrphanedCredentials;
  const schema = getErrorSchema({ httpStatus, code, admin, stepWithOrphanedCredentials });

  const sanitizedOutput = useMemo(() => {
    if (admin) {
      return output;
    }

    if (output?.data?.length) {
      output.data = output.data.map((item) => {
        if (item?.stack) {
          return {
            ...item,
            stack: sanitizeStack(item.stack)
          };
        }
        return item;
      });
    }

    return output;
  }, [admin]);

  useEffect(() => {
    if (schema.component && schema.component !== errorComponent?.name) {
      const Component = React.lazy(() => import(`@/screens/workflows/workflowEditor/workflowEditorPanels/primaryPanels/outputPanel/outputErrorViewer/${schema.component}.jsx`));
      setErrorComponent({ name: schema.component, component: Component });
    }
  }, [schema]);

  return <div className="output-error-viewer">{errorComponent && <errorComponent.component schema={schema} output={sanitizedOutput} />}</div>;
};

export default OutputErrorViewer;
